import { useEffect, useMemo, useRef } from 'react'
import { UnknownQuestionModel } from '../types'
import { unknownQuestionTypeValue } from 'tabs/nlp/components/unansweredQuestions/configs'

export const useOutsideAlerter = <T extends HTMLElement>(callback: VoidFunction) => {
    const reference = useRef<T>()

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (reference.current && !reference.current.contains(event.target)) {
                callback()
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [reference])

    return reference
}

export const useQuestionTrainedStatus = (question: UnknownQuestionModel) => {
    const canBeTrained = useMemo(() => {
        return !!question.answer
            && !!question.type
            && question.type !== unknownQuestionTypeValue
            && !question.isTrained
    }, [question])
    return { canBeTrained }
}
